<template>
	<div class="flex flex-row flex-wrap gap-[4px]">
		<div
			v-for="category in categoriesList"
			:key="category"
			class="flex select-none"
		>
			<div class="w-fit h-fit rounded-[4px] border border-grays-300 py-[3px] px-4">
				<p class="text-base text-grays-800 font-medium">
					{{category}}
				</p>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "categories-menu-view",
  props: {
    categoriesList: {
      type: Array,
      default: () => [],
    }
  },
};
</script>

<style>

</style>